/**
 * NOTE: Some of these fields are used to track AI MAU
 * See this page for more details: https://hello.atlassian.net/wiki/spaces/AAI/pages/3770721410/Unified+event+Instrumentation+for+AI
 */

export var AI_MATE_ATTRIBUTES = {
  agentCreatorType: 'agentCreatorType',
  agentId: 'agentId',
  agentVisibility: 'agentVisibility',
  agentExternalConfigReference: 'agentExternalConfigReference',
  agentActions: 'agentActions',
  agentIsDefault: 'agentIsDefault',
  conversationChannelId: 'conversationChannelId',
  experienceId: 'experienceId',
  fullScreen: 'fullScreen',
  product: 'product',
  productHeader: 'productHeader',
  singleInstrumentationID: 'singleInstrumentationID'
};